(function(){
	'use strict';

  angular
    .module('app.contact')
    .config(routes);

  function routes($stateProvider) {
		$stateProvider
			.state('budget', {
				url: '/orcamento',
				templateUrl: 'contact/layouts/budget.template.html',
				controller: 'BudgetController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('workUs', {
				url: '/trabalhe-conosco',
				templateUrl: 'contact/layouts/workUs.template.html',
				controller: 'WorkUsController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('agents', {
				url: '/representantes',
				templateUrl: 'contact/layouts/agents.template.html',
				controller: 'AgentsController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('contact', {
  			url: '/fale-conosco',
  			templateUrl: 'contact/layouts/contact.template.html',
  			controller: 'ContactController',
  			controllerAs: 'vm',
  			parent: 'main'
  		})
		}

})();
